import React, { useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, List, ListItem, ListItemText, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectRicette,selectIsLoading } from "../../../features/ricette/ricetteSlice";
import { fetchRicette } from "../../../features/ricette/ricetteThunk";
import { selectProduzioni, setSingleProduzioneId } from "../../../features/produzioni/produzioniSlice";
import { createProduzione } from "../../../features/produzioni/produzioniThunk";
import { toast } from "react-toastify";
// import "../production";
const CompanyProduction = ({ setProduction }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const isLoading = useSelector(selectIsLoading);
    const ricette = useSelector(selectRicette);
    // const Produzione = useSelector(selectProduzioni)
    const ricetteId = ricette.id
    useEffect(() => {
      dispatch(fetchRicette())
    }, [dispatch])

    
    
    
    return (
        <Box clasName="box">
            <DialogTitle className="title" sx={{
                fontWeight: "bold", fontSize: "1.2rem", color: '#225CA6', textAlign: "center", transition: "color 0.3s ease-in-out",
                "&:hover": {
                    color: "#57C700",
                }
            }}>
                Scegli una ricetta
            </DialogTitle>
            <DialogContent className="dialogContent" sx={{ display: "flex", flexDirection: "column", alignItems: "center" }} >
            <List sx={{ color: "#225CA6", textAlign: "center" }}>
          {ricette?.map((ricetta, index) => (
            <ListItem
              button
              key={index}
              onClick={async () => {
                const formData = new FormData();
                formData.append('ricette_id', ricetta?.id);
                try {
                  const response = await dispatch(createProduzione(formData)).unwrap(); // unwrap() to handle errors
                  navigate("/produzione/vendemmia");
                  dispatch(setSingleProduzioneId(response.data.id));
                  
                  console.log(response,'akjdbwqkj');
                  
                  setProduction(false);
                } catch (error) {
                  console.error("Failed to create produzione:", error);
                  toast.error('Il ricette è già associato a una produzione esistente')
                }
              }}
            >
              <ListItemText sx={{ textAlign: "center" }} primary={ricetta.name} />
            </ListItem>
          ))}
        </List>
            </DialogContent>
        </Box>
    );
};
export default CompanyProduction;